import React from 'react';
import { motion } from 'framer-motion';
const TARGET_VIDEO = 'https://cdn.magicpatterns.com/uploads/2P6MUi4XoeqGt9s37VXEEe/0410 (1).mp4';
export function TargetAudienceSection() {
  return <section className="w-full bg-white p-0 m-0 leading-[0]" data-id="element-333">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="w-full" data-id="element-334">
        <video src={TARGET_VIDEO} autoPlay loop muted playsInline className="w-full h-auto block m-0 p-0" data-id="element-335" />
      </motion.div>
    </section>;
}